var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M548.21 46.8747C628.118 72.8384 697.755 123.433 747.141 191.407L425.264 425.264L548.21 46.8747Z",
    fill: "url(#paint0_linear_90_27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.318 46.8747C382.226 20.911 468.302 20.911 548.211 46.8746L425.264 425.264L302.318 46.8747Z",
    fill: "url(#paint1_linear_90_27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.958C822.981 509.979 796.239 591.796 746.735 659.683L425.266 425.264L823.127 425.958Z",
    fill: "url(#paint2_linear_90_27)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M747.142 191.406C796.528 259.38 823.127 341.244 823.127 425.264L425.264 425.264L747.142 191.406Z",
    fill: "url(#paint3_linear_90_27)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M548.21 803.654C468.302 829.617 382.226 829.617 302.318 803.654L425.264 425.264L548.21 803.654Z",
    fill: "url(#paint4_linear_90_27)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M747.142 659.122C697.756 727.096 628.119 777.69 548.211 803.654L425.264 425.264L747.142 659.122Z",
    fill: "url(#paint5_linear_90_27)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.388 191.407C152.773 123.433 222.411 72.8387 302.319 46.8749L425.265 425.265L103.388 191.407Z",
    fill: "url(#paint6_linear_90_27)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4024 425.264C27.4024 341.244 54.0014 259.38 103.387 191.406L425.265 425.264L27.4024 425.264Z",
    fill: "url(#paint7_linear_90_27)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.387 659.122C54.0012 591.148 27.4021 509.285 27.4021 425.265L425.264 425.265L103.387 659.122Z",
    fill: "url(#paint8_linear_90_27)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M302.317 803.654C222.409 777.69 152.771 727.096 103.385 659.122L425.263 425.264L302.317 803.654Z",
    fill: "url(#paint9_linear_90_27)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_27",
    x1: 470.162,
    y1: 180.962,
    x2: 678.717,
    y2: 274.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_27",
    x1: 317.991,
    y1: 201.229,
    x2: 541.575,
    y2: 154.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_27",
    x1: 676.431,
    y1: 416.798,
    x2: 602.569,
    y2: 634.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_27",
    x1: 623.216,
    y1: 270.438,
    x2: 692.007,
    y2: 490.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_90_27",
    x1: 532.537,
    y1: 649.299,
    x2: 308.953,
    y2: 696.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_90_27",
    x1: 633.683,
    y1: 565.683,
    x2: 445.995,
    y2: 698.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_90_27",
    x1: 206.795,
    y1: 307.07,
    x2: 360.007,
    y2: 137.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_90_27",
    x1: 183.114,
    y1: 449.818,
    x2: 247.596,
    y2: 215.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_90_27",
    x1: 243.669,
    y1: 660.91,
    x2: 160.404,
    y2: 356.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_90_27",
    x1: 356.121,
    y1: 666.874,
    x2: 171.332,
    y2: 529.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors10);
export default __webpack_public_path__ + "static/media/sectors-10.87fbc66ed89b51f342e41874962a9c55.svg";
export { ForwardRef as ReactComponent };